// Single source of truth for quotation math, used by both the live quotation
// table display and the final-submit payload builder so the two never drift.
// Total per service = (serviceFee × per_time) + transportFee + additionalFee.

export const parseQuotationFee = (value) => {
  const amount = parseFloat(value);
  return Number.isFinite(amount) ? amount : 0;
};

export const parseQuotationPerTime = (value) => {
  if (value === "" || value === null || value === undefined) return 1;
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
};

export const calculateServiceItemTotal = ({ serviceFee, transportFee, additionalFee, perTime }) =>
  parseQuotationFee(serviceFee) * parseQuotationPerTime(perTime) + parseQuotationFee(transportFee) + parseQuotationFee(additionalFee);

export const calculateQuotationTotal = (items = []) => items.reduce((sum, item) => sum + calculateServiceItemTotal(item), 0);
